import './site.css';

// The form remains usable without JavaScript. All selection inputs stay in the form.
const review = document.querySelector<HTMLElement>('[data-chat-review]');
if (review) {
  const chats = [...review.querySelectorAll<HTMLElement>('[data-review-chat]')];
  const links = [...review.querySelectorAll<HTMLButtonElement>('[data-show-chat]')];
  const previous = review.querySelector<HTMLButtonElement>('[data-previous-chat]');
  const next = review.querySelector<HTMLButtonElement>('[data-next-chat]');
  const counter = review.querySelector<HTMLElement>('[data-chat-counter]');
  let position = 0;
  function show(index: number) {
    position = Math.max(0, Math.min(chats.length - 1, index));
    chats.forEach((chat, i) => { chat.hidden = i !== position; });
    links.forEach((link, i) => link.setAttribute('aria-current', String(i === position)));
    if (previous) previous.disabled = position === 0;
    if (next) next.disabled = position === chats.length - 1;
    if (counter) counter.textContent = `${position + 1} / ${chats.length}`;
  }
  links.forEach((link, i) => link.addEventListener('click', () => show(i)));
  previous?.addEventListener('click', () => show(position - 1));
  next?.addEventListener('click', () => show(position + 1));
  review.querySelectorAll<HTMLElement>('[data-review-controls]').forEach(node => { node.hidden = false; });
  if (chats.length) show(0);
}
